'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _type = require('./type');

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _diablo = require('../../mixins/diablo');

var _diablo2 = _interopRequireDefault(_diablo);

var _weexTheme = require('@dolphinweex/weex-theme');

var _dofSpinner = require('../dof-spinner');

var _dofSpinner2 = _interopRequireDefault(_dofSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_colmo2.default, _diablo2.default],
  components: { WeexThemeView: _weexTheme.WeexThemeView, DofSpinner: _dofSpinner2.default },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: '确认'
    },
    size: {
      type: String,
      default: 'full'
    },
    type: {
      type: String,
      default: 'primary'
    },
    pattern: {
      type: String,
      default: 'default'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isHighlight: {
      type: Boolean,
      default: true
    },
    btnStyle: Object,
    textStyle: Object,
    disabledStyle: Object
  },
  computed: {
    mrBtnStyle: function mrBtnStyle() {
      var type = this.type,
          pattern = this.pattern,
          disabled = this.disabled,
          btnStyle = this.btnStyle,
          size = this.size,
          disabledStyle = this.disabledStyle;

      var buttonStyle = _type.BUTTON_STYLE_MAP;
      if (this._isColmo && this.type === 'primary') {
        type = 'colmo';
        buttonStyle = _type.COLMO_BUTTON_STYLE_MAP;
      }

      var styleMap = this._isDiablo ? _extends({}, _type.STYLE_MAP_DIABLO[type][pattern]) : _extends({}, _type.STYLE_MAP[type][pattern]);
      if (!this._isColmo && pattern !== 'text' && !disabled) delete styleMap.backgroundColor;
      var mrBtnStyle = _extends({}, styleMap, buttonStyle[size], btnStyle);

      var disabledInStyle = { opacity: 0.3 };
      if (type === 'white') {
        disabledInStyle = { backgroundColor: 'rgba(0, 0, 0, 0.1)' };
      }

      return disabled ? _extends({}, mrBtnStyle, disabledInStyle, disabledStyle) : mrBtnStyle;
    },
    mrTextStyle: function mrTextStyle() {
      var type = this.type,
          pattern = this.pattern,
          disabled = this.disabled,
          textStyle = this.textStyle,
          size = this.size;

      if (pattern === 'plain_text') pattern = 'text';
      var buttonTextStyle = _type.TEXT_FONTSIZE_STYLE_MAP;
      if (this._isColmo && this.type === 'primary') {
        type = 'colmo';
        buttonTextStyle = _type.COLMO_TEXT_FONTSIZE_STYLE_MAP;
      }
      var textStyleMap = this._isDiablo ? _type.TEXT_STYLE_MAP_DIABLO : _type.TEXT_STYLE_MAP;

      var mrTextStyle = _extends({}, textStyleMap[type][pattern], buttonTextStyle[size], textStyle);
      return disabled ? _extends({}, mrTextStyle) : mrTextStyle;
    },
    loadingGif: function loadingGif() {
      if (this._isColmo) return 'colmo';
      var pattern = this.pattern;

      if (pattern === 'default') {
        return 'white';
      } else {
        return 'black';
      }
    }
  },
  methods: {
    onClicked: function onClicked(e) {
      var type = this.type,
          pattern = this.pattern,
          disabled = this.disabled;

      disabled ? null : this.$emit('dofButtonClicked', { e: e, type: type, pattern: pattern, disabled: disabled });
    },
    onTextClicked: function onTextClicked(e) {
      var type = this.type,
          pattern = this.pattern,
          disabled = this.disabled;

      disabled ? null : this.$emit('dofButtonClicked', { e: e, type: type, pattern: pattern, disabled: disabled });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-button/index.vue
// module id = 311
// module chunks = 0 1